<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import EmployeeDetail from '../../../../../employees/components/EmployeeDetail.vue'
import { EmployeeID } from '../../../../../employees/models/employee'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})

const {
  id,
} = defineProps<{
    id: EmployeeID
}>()
</script>

<template>
  <EmployeeDetail
    :id="id"
  />
</template>